import { t } from "i18next";

import { errors, SHOW_TOKEN_EXP_DEBOUNCE_MS } from "../../constants";
import { Log } from "../log.helpers";

let hasShownUnauthorizedAlert = false;
let alertResetTimeout: ReturnType<typeof setTimeout> | undefined;

export const showTokenExpiredAlert = (): void => {
  if (!hasShownUnauthorizedAlert) {
    hasShownUnauthorizedAlert = true;
    Log.errorAndToast(t(errors.auth.tokenExpiredError));

    clearTimeout(alertResetTimeout);

    alertResetTimeout = setTimeout(() => {
      hasShownUnauthorizedAlert = false;
    }, SHOW_TOKEN_EXP_DEBOUNCE_MS);
  }
};
